var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
class Avatar extends React.Component {
    render() {
        const _a = this.props, { avatarUrl, defaultAvatarUrl, userName, className, size } = _a, otherProps = __rest(_a, ["avatarUrl", "defaultAvatarUrl", "userName", "className", "size"]);
        const avatarCls = classnames('cfm_avatar', `cfm_avatar_${size}`, className);
        return <div className={avatarCls} {...otherProps}>
      {!avatarUrl && userName
            ? <div className='cfm_avatar_inner'>{userName.substr(0, 1)}</div>
            : <div className='cfm_avatar_inner'>
            <img className='cfm_avatar_img' src={avatarUrl || defaultAvatarUrl}/>
          </div>}
    </div>;
    }
}
Avatar.defaultProps = {
    type: 'primary',
    size: 'md',
    userName: '',
    defaultAvatarUrl: '//f.cfcdn.club/assets/ad023982d3c0708792d9fc4f30c1f316_160x160.png',
};
export default Avatar;



// WEBPACK FOOTER //
// ./components/avatar/index.tsx